import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

export const AdminEditCorporateUser = () => {
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            const currentRole = roles.find(r => r.roleName === data.roleName);
            let url = `${API_BASE_URL}/admin/User/UpdateUser`; // API_BASE_URL kullanımı
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    id: data.id,
                    username: document.getElementById("username").value,
                    fullName: document.getElementById("fullName").value,
                    roleId: currentRole ? currentRole.id : data.roleId,
                    createdAt: data.createdAt,
                    lastLogin: data.lastLogin,
                    expiryDate: document.getElementById("expiryDate").value,
                    isTrial: document.getElementById("isTrial").value === "true",
                    isVerified: data.isVerified,
                    isInvidual: data.isInvidual,
                    isStudent: data.isStudent,
                    isManager: data.isManager,
                    schoolId: detail.schoolId,
                    classId: detail.classId,
                    sectionId: detail.sectionId,
                    userNote: ".",
                    status: "."
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {

                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err);
        }
    }
    const getUser = async (e) => {

        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/User/GetUserById`;
            await axios({
                method: 'GET',
                url: url,
                params: {
                    userId: params['id']
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data']['user'])
                        setDetail(res.data['data']['detail'])
                    }
                    else {
                        alert(res.data['message']);
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err);
        }
        setLoading(false);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/Role/GetList`; // API_BASE_URL kullanımı
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {

                if (res.status === 200) {
                    if (res.data['success']) {
                        setRoles(res.data['data']);
                    }
                    else {
                        alert("hata")
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            alert(err.message)
            setMsg(err);
        }
        setLoading(false);
    }
    useEffect(() => {
        getUser();
        fetchData();
    }, [])

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-8 col-xl-7">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-0">{t("editUser")}</h1>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}
                            {loading && <div className="text-center my-4">Veriler Yükleniyor...</div>}

                            {!loading && (
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label for="username" className="form-label">{t("email")}</label>
                                            <textarea className="form-control" id="username" rows={1} defaultValue={data.username} />
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label for="fullName" className="form-label">{t('namesurname')}</label>
                                            <textarea className="form-control" id="fullName" rows={1} defaultValue={data.fullName} />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label className="form-label d-block text-muted small mb-1">{t('createdAt')}</label>
                                            <div>{formatDate(data.createdAt)}</div>
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label className="form-label d-block text-muted small mb-1">{t('lastLogin')}</label>
                                            <div>{formatDate(data.lastLogin)}</div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label className="form-label" for="expiryDate">{t("expiryDate")}</label>
                                            <input type="datetime-local" className="form-control" id="expiryDate" name="expiryDate" defaultValue={data.expiryDate} />
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label for="isTrial" className="form-label">{t('isActive')}</label>
                                            {data.isTrial ? (
                                                <select id="isTrial" className="form-select" required >
                                                    <option key="0" value="true" selected>{t('passive')}</option>
                                                    <option key="1" value="false" >{t('active')}</option>
                                                </select>
                                            ) : (
                                                <select id="isTrial" className="form-select" required >
                                                    <option key="1" value="false" selected>{t('active')}</option>
                                                    <option key="0" value="true" >{t('passive')}</option>
                                                </select>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label for="schoolId" className="form-label">{t('schoolId')}</label>
                                        <textarea className="form-control" id="schoolId" rows={1} defaultValue={detail.schoolId} />
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        <button type="submit" className="btn btn-primary btn-lg px-4">{t('update')}</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AdminEditCorporateUser;
